import { jsx as _jsx } from "react/jsx-runtime";
import { ABTestCookie } from '@as-react/common-types';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useABTest } from '../../../hooks/useABTest';
import { useSaferpay } from '../../../hooks/useSaferpay';
import { PaymentRequestGroupContent } from './PaymentRequestGroupContent';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { NewCreditCardForm } from '../payment/payment-groups/credit-card/NewCreditCardForm';
export const AMEX_BRAND = 'American Express';
export const PaymentRequestGroupCreditCard = ({ selected, group, onSubmit }) => {
    const paymentGroupContentRef = useRef();
    const { t } = useTranslation(I18N_NAMESPACES.buy);
    const { hasBCookie: disableAmexPaymentCookie } = useABTest(ABTestCookie.DISABLE_AMEX_PAYMENT);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showError, setShowError] = useState(false);
    const [saveCreditCardForFutureUse, setSaveCreditCardForFutureUse] = useState(false);
    const paymentMethods = group.paymentOptions.map(option => option.name.toLowerCase());
    let groupOgoneAliases = group.ogoneAliases || [];
    if (disableAmexPaymentCookie) {
        groupOgoneAliases = groupOgoneAliases.filter(card => card.brand !== AMEX_BRAND);
    }
    const isAddNewCardSelected = !groupOgoneAliases.length;
    const { hasError: hasSaferpayError, validation } = useSaferpay({
        paymentMethods,
        cvvPlaceholder: true,
        enabled: selected && isAddNewCardSelected,
    });
    const handleSaveCreditCardChange = () => setSaveCreditCardForFutureUse(prev => !prev);
    const isSubmitDisabled = Boolean(!!hasSaferpayError || showError);
    const newCreditCardFormProps = {
        paymentMethods,
        validation,
        isSubmitDisabled,
        isSubmitting,
        showSaveCardBlock: false,
        saveCreditCard: saveCreditCardForFutureUse,
        onSaveCreditCardChange: handleSaveCreditCardChange,
    };
    const submitWithNewCard = () => {
        window.SaferpayFields.submit({
            onSuccess: ({ token }) => {
                try {
                    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(token);
                }
                catch (_a) {
                    setIsSubmitting(false);
                    setShowError(true);
                }
            },
            onError: () => {
                setIsSubmitting(false);
            },
        });
    };
    const onHandleSubmit = () => {
        setIsSubmitting(true);
        setShowError(false);
        submitWithNewCard();
    };
    return (_jsx(PaymentRequestGroupContent, { onSubmit: onHandleSubmit, selected: selected, group: group, disabled: isSubmitDisabled, isSubmitting: isSubmitting, error: hasSaferpayError || showError ? t('buy.payment.form.error') : undefined, innerRef: paymentGroupContentRef, children: selected && _jsx(NewCreditCardForm, Object.assign({}, newCreditCardFormProps)) }));
};
